import { useContext, useMemo } from 'react';
import FormContext from '../store/form-context';

const parseReferrer = (referrer?: string) => {
  if (!referrer) return { source: '(none)', medium: undefined };

  try {
    const url = new URL(referrer);
    const hostname = url.hostname.replace('www.', '');

    if (hostname.includes('facebook.com')) return { source: 'facebook', medium: 'social' };
    if (hostname.includes('instagram.com')) return { source: 'instagram', medium: 'social' };
    if (hostname.includes('linkedin.com') || hostname.includes('lnkd.in')) return { source: 'linkedin', medium: 'social' };
    if (hostname.includes('youtube.com')) return { source: 'youtube', medium: 'social' };
    if (hostname.includes('t.co') || hostname.includes('x.com') || hostname.includes('twitter.com')) return { source: 'twitter', medium: 'social' };
    if (hostname.includes('google.com')) return { source: 'google', medium: 'organic' };
    if (hostname.includes('bing.com')) return { source: 'bing', medium: 'organic' };
    if (hostname.includes('linktr.ee')) return { source: 'linktree', medium: 'social' };

    return { source: referrer, medium: undefined };
  } catch (e) {
    return { source: referrer, medium: undefined };
  }
};

export const useTrafficSource = () => {
  const {
    trafficSource,
    urlTrafficSource,
    urlTrafficMedium,
    urlTrafficCampaign,
    documentReferrer,
  } = useContext(FormContext);

  return useMemo(() => {
    let finalTrafficSource: string | undefined;
    let finalTrafficMedium: string | undefined;
    let finalTrafficCampaign: string | undefined;

    if (urlTrafficSource) {
      finalTrafficSource = urlTrafficSource;
      finalTrafficMedium = urlTrafficMedium;
      finalTrafficCampaign = urlTrafficCampaign;
    } else if (trafficSource) {
      finalTrafficSource = trafficSource;
    } else {
      const parsed = parseReferrer(documentReferrer);
      finalTrafficSource = parsed.source;
      finalTrafficMedium = parsed.medium;
    }

    return {
      traffic_source: finalTrafficSource,
      traffic_medium: finalTrafficMedium,
      traffic_campaign: finalTrafficCampaign,
    };
  }, [trafficSource, urlTrafficSource, urlTrafficMedium, urlTrafficCampaign, documentReferrer]);
};
